import { useState } from "react";

export default function PromoTermsHook() {
    const [status, setStatus] = useState(false);
    const [data, setData] = useState({});
    const open = () => { setStatus(true) };
    const close = () => setStatus(false);

    return {
        status: status,
        data: data,
        setData: setData,
        func: {
            open,
            close
        },
    };
}